// extracted by mini-css-extract-plugin
export default {"root":"TqSnNUM3","content":"BhU9P1FJ","title":"aTRfEEH0","description":"WhWhVU8o"};